import FullScreenBtn from "@home/pages/studio/components/FullScreenBtn";
import Insights from "@home/pages/studio/socialIndex/components/Insights";
import InsightsCard from "@home/pages/studio/socialIndex/components/Insights/component/InsightsCard";
import InsightsEdit from "@home/pages/studio/socialIndex/components/Insights/component/InsightsEdit";
import MetricsBreakdownTable from "@home/pages/studio/socialIndex/components/MetricsBreakdownTable";
import OverallIndex from "@home/pages/studio/socialIndex/components/OverallIndex";
import MetricsBreakdownTableService from "@home/pages/studio/socialIndex/components/MetricsBreakdownTableService";
import SocialFilter from "@home/pages/studio/socialIndex/components/SocialFilter";


export default {
  SocialFilter,
  FullScreenBtn,
  OverallIndex,
  Insights,
  InsightsCard,
  InsightsEdit,
  MetricsBreakdownTable,
  MetricsBreakdownTableService,
};